import axios from "axios";
import { CONST } from "../config/const";

// ファイルアップロード用署名付きURL取得（CSV）
export async function getPresignedPostCSV(
  nowTimeName: string,
  fileName: string
) {
  try {
    const path = "presigned_post/csv";
    const params = { nowTimeName, fileName };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    const presigned_object = response.data.presigned_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_key = response.data.destination_key as string;
    return { presigned_object, destination_key };
  } catch (error) {
    // logout();
    return { presigned_object: { fields: {}, url: "" }, destination_key: "" };
  }
}

// ファイルダウンロード用署名付きURL取得（画像）
export async function getPresignedGetPicture(destination_key: string) {
  try {
    const path = "presigned_get/picture";
    const params = { destination_key };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    return response.data.header_location;
  } catch (error) {
    // logout();
  }
}
// ファイルダウンロード用署名付きURL取得（外部サイトファイル）
export async function getPresignedGetOutsideFile(destination_key: string) {
  try {
    const path = "presigned_get/outsideFile";
    const params = { destination_key };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    return response.data.header_location;
  } catch (error) {
    // logout();
  }
}

// ファイルアップロード用署名付きURL取得（画像）
export async function getPresignedPostPicture(
  nowTimeName: string,
  fileName: string
) {
  try {
    const path = "presigned_post/picture";
    const params = { nowTimeName, fileName };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    const presigned_object = response.data.presigned_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_key = response.data.destination_key as string;
    return { presigned_object, destination_key };
  } catch (error) {
    // logout();
    return { presigned_object: { fields: {}, url: "" }, destination_key: "" };
  }
}

// ファイルアップロード用署名付きURL取得（外部サイトのファイル）
export async function getPresignedPostOutsideFile(
  editType: string,
  oldValue: string,
  fileName: string
) {
  try {
    const path = "presigned_post/outsideFile";
    const params = { editType, oldValue, fileName };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    const presigned_object = response.data.presigned_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_key = response.data.destination_key as string;
    return { presigned_object, destination_key };
  } catch (error) {
    // logout();
    return { presigned_object: { fields: {}, url: "" }, destination_key: "" };
  }
}

// ファイルダウンロード用署名付きURL取得（画像）
export async function getSampleCSV(
  postCSVPath: string,
  product_id: number | null,
  product_name: string | null,
  category_id: number | null,
  category_name: string | null
) {
  try {
    const path = "sampleCSV";
    const params = {
      path: postCSVPath,
      product_id,
      product_name,
      category_id,
      category_name,
    };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    return response.data.header_location;
  } catch (error) {
    // logout();
  }
}

// 署名付きURLでファイルアップロード
export async function postPresignedPost(url: string, formData: FormData) {
  try {
    await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        accept: "multipart/form-data",
      },
    });
    return "seccess";
  } catch (error) {
    // logout();
    return "failed";
  }
}

// アップロードCSVのヘッダー情報取得
export async function getPostCSVHeader(
  destination_key: string,
  product_id: null | number
) {
  try {
    const path = "presigned_post/csv/header";
    const params = { destination_key, product_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const headers = response.data.headers as string[];
    const csv_column = response.data.csv_column[0].csv_column as {
      [key: string]: string;
    };
    return { headers, csv_column };
  } catch (error) {
    // logout();
    return { headers: [], csv_column: {} };
  }
}
